
import Vue from 'vue';

export default Vue.extend({
  name: "XOverlay",
  props: {
    value: {
      type: Boolean
    },
    gapX: {
      type: Number,
      default: 0
    },
    gapY: {
      type: Number,
      default: 0
    },
    position: {
      type: String,
      default: 'bottom left'
    },
  },
  data() {
    return {
      val: this.value,
      activatorComponent: {}
    }
  },
  watch: {
    value(val) {
      this.val = val;
    },
  },
  methods: {
    onClick() {
      this.val = true;
    },
    calculateDropdownPosition() {
      if (this.position.includes('top')) {
        this.$refs.dropdown.style.top = -this.activatorComponent.clientHeight + this.gapY + 'px';
      }
      if (this.position.includes('bottom')) {
        this.$refs.dropdown.style.top = this.activatorComponent.clientHeight + this.gapY + 'px';
      }
      if (this.position.includes('left')) {
        this.$refs.dropdown.style.left = this.gapX + 'px';
      }
      if (this.position.includes('right')) {
        this.$refs.dropdown.style.right = this.gapX + 'px';
      }
    },
    calculateDropdownContainerPosition() {
      const activatorPosition = this.activatorComponent.getBoundingClientRect();
      this.$refs.dropdownContainer.style.top = activatorPosition.top + 'px';
      this.$refs.dropdownContainer.style.left = activatorPosition.left + 'px';
    }
  },
  created() {
    setTimeout(() => {
      if (this.$refs.overlay) {
        this.$root.$children[0].$children[0].$el.append(this.$refs.overlay);
        this.activatorComponent = this.$scopedSlots.activator({on: this.onClick})[0].context.$refs.activator;
        if (this.activatorComponent.$el) {
          this.activatorComponent = this.activatorComponent.$el;
        }
        this.calculateDropdownPosition();
        this.calculateDropdownContainerPosition();
      }
    }, 100)
  },
  destroyed() {
    // this.$el.parentNode.removeChild(this.$refs.overlay);
  }
})
